import { useQuery, useMutation } from '@tanstack/react-query'
import { instagramService, authService } from '@/services'

export { useUserWatchlists } from './use-user-watchlists'

export { useToast } from './use-toast'
export { useSavedInfluencers } from './use-saved-influencers'

// Query keys
const queryKeys = {
  user: ['user'],
  search: (query: string) => ['search', query],
  analytics: (params: any) => ['analytics', params],
}

// Auth
export const useCurrentUser = () => 
  useQuery({
    queryKey: queryKeys.user,
    queryFn: authService.getCurrentUser,
    staleTime: 5 * 60 * 1000,
    retry: false,
  })

// Search
export const useSearchInfluencers = () => {
  return useMutation({
    mutationFn: instagramService.searchInfluencers,
  })
}

// Analytics
export const useAnalyzeProfile = () => {
  return useMutation({
    mutationFn: instagramService.analyzeAccount,
  })
} 